import {Component} from '@angular/core';
import {NavController, AlertController ,ToastController} from 'ionic-angular';
import {Api} from '../../providers/api';
import {CartManager} from '../../providers/cart-manager';
import {MsgManager} from "../../providers/msg-manager";
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'page-change-password',
  templateUrl: 'change-password.html'
})
export class ChangePasswordPage {
	public passwordChange: any;

  constructor(
    public nav: NavController ,
    private alertController:AlertController,
    private api:Api,
    private cartManager:CartManager,
    private toastController:ToastController,
    private msgManager:MsgManager,
    private gVLogger: GVLogger) {
  	this.passwordChange = {
  		old: "",
  		new: "",
  		confirm: ""
  	}
  }

  changePassword(){
  	if(this.passwordChange.old == ""){
  		this.presentAlert("Can't proceed","Please Enter The Old password first","ok");
  	}else if(this.passwordChange.new == ""){
		this.presentAlert("Can't proceed","Please Enter The New password first","ok");
  	}else if(this.passwordChange.confirm == ""){
  		this.presentAlert("Can't proceed","Please Enter The Confirm password first","ok");
  	}else if(this.passwordChange.new != this.passwordChange.confirm){
  		this.presentAlert("Can't proceed","New password and confirm password doesn't match","ok");
  	}else{
  		let alert = this.alertController.create({
	    title: 'Confirm action',
	    message: 'Do you want to change password?',
	    buttons: [
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          this.gVLogger.log('Cancel clicked');
	        }
	      },
	      {
	        text: 'confirm',
	        handler: () => {
	          this.gVLogger.log('Password change button clicked');

            let body = "?userId="+this.cartManager.getSalesManId()
            +"&userName="+this.cartManager.getLoginUserName()
            +"&userCountry="+this.cartManager.getLoginUserCountry()
                        +"&oldPassword="+this.passwordChange.old
                        +"&newPassword="+this.passwordChange.confirm;


            this.gVLogger.log(body);
            this.api.postRA("/api/v1/users/changePassword/"+body,null)
            .map(res => res.json())
            .subscribe(resp => {
              this.gVLogger.log(JSON.stringify(resp));
            if(resp.status=="200"){
               this.msgManager.toastMsg(this.msgManager.getPasswordChangeSuccessMsg());
              this.nav.pop();
            }else{
              this.presentAlert("Failed",resp.message,"ok");
            }
	        });
        }
      }
	    ]
	  });
	  alert.present();
  	}
  }


  presentAlert(title,msg,buttonText) {
    let alert = this.alertController.create({
      title: title,
      subTitle: msg,
      buttons: [buttonText]
    });
    alert.present();
  }


}



// WEBPACK FOOTER //
// ./src/pages/change-password/change-password.ts